// reCAPTCHA Configuration and Utilities
export const RECAPTCHA_CONFIG = {
  // Get the site key from environment or fallback to test key
  SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',

  // Check if we're using the test key (for development)
  IS_TEST_KEY: (process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI') === '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',

  // Environment detection
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',

  // Domain configuration
  ALLOWED_DOMAINS: [
    'localhost',
    '127.0.0.1',
    'test.web-pcab.nbtechbeta.com'
  ]
};

// Debug information
export const getRecaptchaDebugInfo = () => {
  return {
    siteKey: RECAPTCHA_CONFIG.SITE_KEY,
    isTestKey: RECAPTCHA_CONFIG.IS_TEST_KEY,
    environment: process.env.NODE_ENV,
    isDevelopment: RECAPTCHA_CONFIG.IS_DEVELOPMENT,
    currentDomain: window.location.hostname,
    allowedDomains: RECAPTCHA_CONFIG.ALLOWED_DOMAINS
  };
};

// Log debug information in development
if (RECAPTCHA_CONFIG.IS_DEVELOPMENT) {
  console.log('reCAPTCHA Debug Info:', getRecaptchaDebugInfo());
}

export default RECAPTCHA_CONFIG;
